import {
  FaFileAlt,
  FaIdBadge,
  FaClipboardList,
  FaBuilding,
  FaUserTie,
  FaTags,
  FaTruck,
  FaUserFriends,
  FaBriefcase,
  FaBook,
  FaCogs,
  FaChartLine,
  FaShoppingCart,
  FaHandshake,
  FaHospital,
  FaUniversity,
  FaTools,
  FaUsersCog,
} from "react-icons/fa";

export const DEFAULT_REGISTRATION_PAGE_ICON = "FaFileAlt";

export const REGISTRATION_PAGE_ICON_COMPONENTS = {
  FaFileAlt,
  FaIdBadge,
  FaClipboardList,
  FaBuilding,
  FaUserTie,
  FaTags,
  FaTruck,
  FaUserFriends,
  FaBriefcase,
  FaBook,
  FaCogs,
  FaChartLine,
  FaShoppingCart,
  FaHandshake,
  FaHospital,
  FaUniversity,
  FaTools,
  FaUsersCog,
};

export const REGISTRATION_PAGE_ICON_OPTIONS = [
  {
    value: "FaFileAlt",
    label: "Documento",
    Icon: FaFileAlt,
  },
  {
    value: "FaIdBadge",
    label: "Identificação",
    Icon: FaIdBadge,
  },
  {
    value: "FaClipboardList",
    label: "Lista de verificações",
    Icon: FaClipboardList,
  },
  {
    value: "FaBuilding",
    label: "Empresa",
    Icon: FaBuilding,
  },
  {
    value: "FaUserTie",
    label: "Colaboradores",
    Icon: FaUserTie,
  },
  {
    value: "FaTags",
    label: "Produtos e serviços",
    Icon: FaTags,
  },
  {
    value: "FaTruck",
    label: "Logística",
    Icon: FaTruck,
  },
  {
    value: "FaUserFriends",
    label: "Clientes e parceiros",
    Icon: FaUserFriends,
  },
  {
    value: "FaBriefcase",
    label: "Projetos",
    Icon: FaBriefcase,
  },
  {
    value: "FaBook",
    label: "Conhecimento",
    Icon: FaBook,
  },
  {
    value: "FaCogs",
    label: "Configurações",
    Icon: FaCogs,
  },
  {
    value: "FaChartLine",
    label: "Performance",
    Icon: FaChartLine,
  },
  {
    value: "FaShoppingCart",
    label: "Compras",
    Icon: FaShoppingCart,
  },
  {
    value: "FaHandshake",
    label: "Parcerias",
    Icon: FaHandshake,
  },
  {
    value: "FaHospital",
    label: "Saúde",
    Icon: FaHospital,
  },
  {
    value: "FaUniversity",
    label: "Educação",
    Icon: FaUniversity,
  },
  {
    value: "FaTools",
    label: "Manutenção",
    Icon: FaTools,
  },
  {
    value: "FaUsersCog",
    label: "Gestão",
    Icon: FaUsersCog,
  },
];

export const resolveRegistrationPageIcon = (iconName) => {
  if (typeof iconName !== "string") {
    return REGISTRATION_PAGE_ICON_COMPONENTS[DEFAULT_REGISTRATION_PAGE_ICON];
  }
  return (
    REGISTRATION_PAGE_ICON_COMPONENTS[iconName] ||
    REGISTRATION_PAGE_ICON_COMPONENTS[DEFAULT_REGISTRATION_PAGE_ICON]
  );
};

export const normalizeRegistrationPageIcon = (iconName) => {
  if (typeof iconName !== "string") {
    return DEFAULT_REGISTRATION_PAGE_ICON;
  }
  return REGISTRATION_PAGE_ICON_COMPONENTS[iconName]
    ? iconName
    : DEFAULT_REGISTRATION_PAGE_ICON;
};
